import mainPoster from "../assets/matching-master-bg.png";

export default function HeroSec() {
  return (
    <section class="bg-[#F2F1F6]">
      <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
        <a
          href="#"
          class="inline-flex justify-between items-center py-1 px-4 pr-4 mb-7 text-sm  rounded-full bg-[#E79014] text-black hover:bg-black"
          role="alert"
        >
          <span class="text-sm text-white font-medium py-1.5">
            Matching Master
          </span>
          {/* <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg> */}
        </a>
        <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl text-[#E79014]">
          Welcome to Matching Master - The Ultimate Memory Game!
        </h1>
        <p class="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48 text-gray-700">
          Step into the future of writing with Essay Writer Pro, the
          groundbreaking app designed to elevate your essay writing experience.
          Whether you are a student, professional, or content creator, Essay
          Writer Pro combines cutting-edge AI technology with intuitive
          functionality to help you create high-quality content effortlessly.
        </p>
        <div class="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.aiwriter&pcampaignid=web_share"
            class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center rounded-lg border focus:ring-4 text-black border-gray-700 hover:bg-gray-300 focus:ring-gray-800"
          >
            Download App
          </a>
        </div>
        <div className="images flex gap-x-5 justify-center items-center">
          <img
            className="mt-3 h-2/3 lg:w-2/3"
            src={mainPoster}
            alt="Main poster background image"
          />
        </div>
      </div>
    </section>
  );
}
